"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var CPPCodeBlock_1 = require("./CPPCodeBlock");

var CPPIfBlock = function () {
    function CPPIfBlock() {
        _classCallCheck(this, CPPIfBlock);

        this.conditions = {};
        this.elseCondition = [];
    }

    _createClass(CPPIfBlock, [{
        key: "defineCondition",
        value: function defineCondition(condition, body) {
            this.conditions[condition] = body;
            return this;
        }
    }, {
        key: "defineElseCondition",
        value: function defineElseCondition(body) {
            this.elseCondition = body;
            return this;
        }
    }, {
        key: "write",
        value: function write(formatter) {
            var indentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (Object.keys(this.conditions).length == 0) {
                return '';
            }
            var ifBlocks = [];
            var first = true;
            for (var condition in this.conditions) {
                var signature = "if (" + condition + ")";
                if (!first) {
                    signature = 'else ' + signature;
                }
                ifBlocks.push(new CPPCodeBlock_1.default(signature, this.conditions[condition]));
                first = false;
            }
            if (this.elseCondition.length > 0) {
                ifBlocks.push(new CPPCodeBlock_1.default('else', this.elseCondition));
            }
            var output = '';
            ifBlocks.forEach(function (element) {
                output += element.write(formatter, indentCount) + '\n';
            });
            return output.replace(/[\s\n]*$/g, '');
        }
    }]);

    return CPPIfBlock;
}();

exports.default = CPPIfBlock;